export async function updateBankAccount(bankAccountRepository, bankAccount, bankAccountId) {
  return bankAccountRepository.update(bankAccount, bankAccountId);
};

